import { render, staticRenderFns } from "./productslider.vue?vue&type=template&id=0c306920&"
import script from "./productslider.vue?vue&type=script&lang=js&"
export * from "./productslider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports